module.exports = "../../app/cells/pages/questions/resource_limit_counter_cell.rb";